import styled from "styled-components";

export const StyledCaret = styled.div<{
  isHighlight: boolean;
}>`
  width: 1px;
  position: absolute;
  pointer-events: none;
  background: ${props => (props.isHighlight ? "#FFFFFF" : "var(--Text_Primary)")};
  will-change: transform, opacity;
`;
